import { render, staticRenderFns } from "./SS.vue?vue&type=template&id=50d33f5c&scoped=true&"
import script from "./SS.vue?vue&type=script&lang=js&"
export * from "./SS.vue?vue&type=script&lang=js&"
import style0 from "./SS.vue?vue&type=style&index=0&id=50d33f5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d33f5c",
  null
  
)

export default component.exports